module.exports = __webpack_public_path__ + "img/angststoerungen_640.aa9e82d1.webp";